"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inquiry = void 0;
var qs = require("qs");
exports.inquiry = function (axios) {
    return {
        // [Inquiry ]
        getInquiries: function (getInquiriesRequest) {
            return axios.get('/inquiries', getInquiriesRequest);
        },
        putInquiries: function (putInquiriesRequest) {
            return axios.put('/inquiries', putInquiriesRequest.data);
        },
        getInquiriesInquiryNo: function (getInquiriesInquiryNoRequest) {
            return axios.get("/inquiries/" + getInquiriesInquiryNoRequest.params.inquiryNo);
        },
        deleteInquiriesInquiryNoFile: function (request) {
            var pathParams = request.pathParams, params = request.params;
            var query = qs.stringify(params);
            return axios.delete("/inquiries/" + pathParams.inquiryNo + "/file?" + query);
        },
        getInquiriesInquiryNoHistories: function (getInquiriesInquiryNoHistoriesRequest) {
            return axios.get("/inquiries/" + getInquiriesInquiryNoHistoriesRequest.params.inquiryNo + "/histories");
        },
        postInquiriesInquiryNoAnswer: function (postInquiriesInquiryNoAnswerRequest) {
            return axios.post("/inquiries/" + postInquiriesInquiryNoAnswerRequest.params.inquiryNo + "/answer", postInquiriesInquiryNoAnswerRequest.data);
        },
        getInquiriesInquiryNoAnswer: function (getInquiriesInquiryNoAnswerRequest) {
            return axios.get("/inquiries/" + getInquiriesInquiryNoAnswerRequest.params.inquiryNo + "/answer");
        },
        deleteInquiriesInquiryNoAnswerFile: function (request) {
            var pathParams = request.pathParams, params = request.params;
            var query = qs.stringify(params);
            return axios.delete("/inquiries/" + pathParams.inquiryNo + "/answer/file?" + query);
        },
        getManageInquiresSummary: function (getManageInquiresSummary) {
            return axios.get('/inquiries/summary', getManageInquiresSummary);
        },
        getInquiriesConfigurations: function (getInquiriesRequestConfigurations) {
            return axios.get('/inquiries/configurations', getInquiriesRequestConfigurations);
        },
        putInquiriesConfigurations: function (_a) {
            var data = _a.data;
            return axios.put('/inquiries/configurations', data);
        },
        getInquiriesCounts: function (getInquiriesCountsRequest) {
            return axios.get('/inquiries/counts', getInquiriesCountsRequest);
        },
        getInquiriesCountsMember: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/inquiries/counts/member?" + query);
        },
    };
};
